import PageContextWrapper from "@components/Components/Reusables/PageContextWrapper";
import dynamic from "next/dynamic";
import { handleRateLimit } from "utils/handleRateLimit";
import { getClientIp } from "utils/requestHelpers";

const DeliveryPage = dynamic(() => import("../js/Components/Delivery/Delivery"));

//Dynamically load the home component and return it
const delivery = ({ data }) => {
    return (
        <>
            <PageContextWrapper
                page='delivery'
                page_content={data.template_page_content}
            >
                <DeliveryPage {...data} />
            </PageContextWrapper>
        </>
    );
};

export async function getServerSideProps({ req, res }) {
    const { headers } = getClientIp(req);

    try {
        const apiReq = await fetch(`${process.env.NEXT_PUBLIC_BASE_API_URL}delivery`, { headers });

        let data = null;

        try {
            data = await apiReq.json();
        } catch (error) {
            console.error('Invalid API response:', error);
        }

        const rateLimitRedirect = handleRateLimit(res, apiReq, data);
        if (rateLimitRedirect) return rateLimitRedirect;

        if (!data || data?.exception) {
            return { notFound: true }
        }

        return {
            props: {
                data
            }
        };

    } catch (error) {
        return { notFound: true }
    }
}

export default delivery;
